module.exports = __webpack_public_path__ + "img/ysjts.4dd9ee7f.png";